import { ClipboardCheck, Landmark, TriangleAlert } from 'lucide-react';

/**
 * One icon per core entity, used wherever an asset, an inspection or a damage is
 * named (page headers, cards, lists, navigation) so the three stay recognisable
 * at a glance. Import these instead of picking a lucide icon ad hoc.
 */
export const AssetIcon = Landmark;
export const InspectionIcon = ClipboardCheck;
export const DamageIcon = TriangleAlert;
